<template>
    <div class="pt-3">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <button class="btn btn-info my-2 my-sm-0"
                        @click="onCreatePlastic"
                        type="button">
                    จัดการราคาเม็ด
                </button>
                &nbsp
                <button class="btn btn-info my-2 my-sm-0"
                        @click="onCreate"
                        type="button">
                    เพิ่มสินค้า
                </button>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ราคา/ใบ</th>
                    <th scope="col">น้ำหนัก/ใบ</th>
                    <th scope="col">ราคาขาย/กิโล</th>
                    <th scope="col">ราคาเม็ด/กิโล</th>
                    <th scope="col">ค่าใช้จ่าย/กิโล</th>
                    <th scope="col">รวมต้นทุน</th>
                    <th scope="col">กำไร/กิโล</th>
                    <th scope="col">จัดการ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(x,i) in list">
                    <td>{{ x.sku }}</td>
                    <td>{{ x.price | currency() }}</td>
                    <td>{{ x.weight | currency() }}</td>
                    <td>{{ 1000 / x.weight * x.price | currency() }}</td>
                    <td>{{ x.plastic  | currency() }}</td>
                    <td>{{ x.cost  | currency() }}</td>
                    <td>{{ x.plastic + x.cost | currency() }}</td>
                    <td>{{ (1000 / x.weight * x.price) - (x.plastic + x.cost) | currency() }}</td>
                    <td>
                        <a @click="onEdit(x.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp;&nbsp;
                        <a @click="onDelete(x.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--        <div v-if="list.length > 0">-->
        <!--            <vue-pagination :pagination="dataPaginate"-->
        <!--                            @paginate="getList">-->
        <!--            </vue-pagination>-->
        <!--        </div>-->
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal hide-header hide-footer ref="form_modal" no-close-on-backdrop>
            <div style="text-align: center;">
                <h4>ค่าต้นทุน</h4>
                <br/>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">รหัสสินค้า*</div>
                    <div class="col-sm-8">
                        <multiselect
                            v-model="form.product_id"
                            :options="optionProducts"
                            track-by="id"
                            :customLabel="LabelSkuWithName"
                            :show-labels="false"
                            placeholder="รหัสสินค้า">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">ราคา/ใบ*</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="ราคา/ใบ"
                            v-model="form.price"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">น้ำหนัก/ใบ*</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="น้ำหนัก/ใบ"
                            v-model="form.weight"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">ชนิดพลาสติก*</div>
                    <div class="col-sm-8">
                        <multiselect
                            v-model="form.option_plastic"
                            :options="optionPlastic"
                            track-by="id"
                            :show-labels="false"
                            :customLabel="LabelPlastic"
                            :allowEmpty="false"
                            @input="getProductPlastic"
                            placeholder="ชนิดพลาสติก">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">ราคาเม็ด/กิโล*</div>
                    <div class="col-sm-8">
                        <input
                            readonly
                            class="form-control"
                            placeholder="ราคาเม็ด/กิโล"
                            v-model="form.plastic"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">ค่าใช้จ่าย/กิโล*</div>
                    <div class="col-sm-8">
                        <input
                            readonly
                            class="form-control"
                            placeholder="ค่าใช้จ่าย/กิโล"
                            v-model="form.cost"/>
                    </div>
                </div>
                <br>
                <button @click="onConfirm()"
                        type="button"
                        :disabled="isRequired"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="onCancel"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="plastic_modal" no-close-on-backdrop>
            <div style="text-align: center;">
                <h4>จัดการราคาเม็ด</h4>
                <br/>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">ชนิดพลาสติก*</div>
                    <div class="col-sm-8">
                        <multiselect
                            v-model="plastic.plastic_type"
                            :options="optionPlastic"
                            track-by="id"
                            :show-labels="false"
                            :customLabel="LabelPlastic"
                            :allowEmpty="false"
                            @input="getPlastic"
                            placeholder="ชนิดพลาสติก">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">ราคาเม็ด/กิโล*</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="ราคาเม็ด/กิโล"
                            v-model="plastic.plastic"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">ค่าใช้จ่าย/กิโล*</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="ค่าใช้จ่าย/กิโล"
                            v-model="plastic.cost"/>
                    </div>
                </div>
                <br>
                <button @click="onConfirmPlastic()"
                        :disabled="isRequiredPlastic"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="onCancelPlastic"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../Pagination";
import Multiselect from "vue-multiselect";

import {canViewSuperAdmin} from "../../util/Permissions";

import Loading from "../Utility/Loading";
import DatePicker from "vue2-datepicker";
import Button from "bootstrap-vue/es/components/button/button";

export default {
    name: "product-cost1",
    components: {
        Button,
        Loading,
        VuePagination,
        Multiselect,
        DatePicker
    },
    data() {
        return {
            msg: '',
            status: '',
            list: [],
            listPlastic: [],
            optionPlastic: [
                {id: 'PS'},
                {id: 'PP'},
                {id: 'PET'},
            ],
            form: {
                id: null,
                product_id: null,
                price: null,
                weight: null,
                plastic: null,
                option_plastic: null,
                cost: null,
                type: 1
            },
            plastic: {
                id: null,
                plastic_type: null,
                plastic: null,
                cost: null,
                type: 1
            }
        };
    },
    created() {
    },
    mounted() {
        this.getList();
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionProducts: (state) => {
                return state.Products.product_all.filter(x => x.product_type_id == 1);
            }
        }),
        isRequired() {
            if (this.form.product_id && this.form.price && this.form.weight && this.form.plastic && this.form.cost)
                return false;
            return true;
        },
        isRequiredPlastic() {
            if (this.plastic.plastic_type && this.plastic.plastic && this.plastic.cost)
                return false;
            return true;
        }
    },
    methods: {
        getProductPlastic() {
            if (this.form.option_plastic) {
                let filter = this.listPlastic.filter(x => {
                    return x.plastic_type == this.form.option_plastic.id
                })
                if (filter.length > 0) {
                    this.form.plastic = filter[0].plastic
                    this.form.cost = filter[0].cost
                }
            }
        },
        getPlastic() {
            if (this.plastic.plastic_type) {
                let filter = this.listPlastic.filter(x => {
                    return x.plastic_type == this.plastic.plastic_type.id
                })
                if (filter.length > 0)
                    this.plastic = {
                        id: filter[0].id,
                        plastic: filter[0].plastic,
                        cost: filter[0].cost,
                        plastic_type: {id: filter[0].plastic_type},
                        type: 1
                    }
                else
                    this.clearPlastic();
            } else
                this.clearPlastic();
        },
        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku}`
            }
        },
        LabelPlastic(option) {
            if (this.optionPlastic.length > 0) {
                return `${option.id}`
            }
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getList() {
            this.msg = 'กำลังโหลดข้อมูล กรุณารอสักครู่';
            this.status = 1;
            this.showLoadingModal();
            let data = {
                // page: this.dataPaginate.current_page,
                type: 1
            };
            this.$store.dispatch('Standard/getCostList', data).then(res => {
                this.list = res;
                this.$store.dispatch('Standard/getPlasticList', data).then(res2 => {
                    this.listPlastic = res2
                    this.hideLoadingModal();
                })
            })
        },
        onEdit(id) {
            this.$store.dispatch('Standard/showCost', id).then(res => {
                res.data.product_id = res.data.product;
                res.data.option_plastic = {id: res.data.plastic_type};
                this.form = res.data;
                this.getProductPlastic();
                this.$refs.form_modal.show();
            })
        },
        onDelete(id) {
            if (confirm('ต้องการลบรายการนี้หรือไม่'))
                this.$store.dispatch('Standard/deleteCost', id).then(() => {
                    this.getList();
                })
        },
        onCreate() {
            this.clearModal();
            this.$refs.form_modal.show();
        },
        onConfirm() {
            this.form.product_id = this.form.product_id ? this.form.product_id.id : '';
            this.form.plastic_type = this.form.option_plastic ? this.form.option_plastic.id : '';
            this.updatePlasticType();
        },
        onCancel() {
            this.$refs.form_modal.hide();
        },
        onCreatePlastic() {
            this.clearModal();
            this.$refs.plastic_modal.show();
        },
        onConfirmPlastic() {
            // this.plastic.plastic_type = this.plastic.plastic_type ? this.plastic.plastic_type.id : '';
            this.$store.dispatch('Standard/savePlastic', this.plastic).then(() => {
                this.updatePlasticType();
            })
        },
        onCancelPlastic() {
            this.clearPlastic()
            this.$refs.plastic_modal.hide();
        },
        clearModal() {
            this.form = {
                id: null,
                product_id: null,
                price: null,
                weight: null,
                plastic: null,
                option_plastic: this.form.option_plastic ? this.form.option_plastic : null,
                cost: null,
                type: 1
            }
        },
        clearPlastic() {
            this.plastic = {
                id: null,
                plastic: null,
                cost: null,
                plastic_type: null,
                type: 1
            }
        },
        updatePlasticType() {
            this.showLoadingModal();
            this.$store.dispatch('Standard/saveCost', this.form).then(() => {
                this.$store.dispatch('Standard/getCostList', {type: 1}).then(res => {
                    this.list = res;
                    this.$store.dispatch('Standard/getPlasticList', {type: 1}).then(res2 => {
                        this.listPlastic = res2
                        let filterUpdate;
                        if (this.plastic.plastic_type) {
                            filterUpdate = this.list.filter(x => {
                                return x.plastic_type == this.plastic.plastic_type && (x.plastic != this.plastic.plastic || x.cost != this.plastic.cost)
                            })
                            filterUpdate = filterUpdate.map(x => {
                                let temp = Object.assign({}, x);
                                temp.plastic = this.plastic.plastic;
                                temp.cost = this.plastic.cost
                                return temp;
                            })
                        } else if (this.form.plastic_type) {
                            filterUpdate = this.list.filter(x => {
                                return x.plastic_type == this.form.plastic_type && (x.plastic != this.form.plastic || x.cost != this.form.cost)
                            })
                            filterUpdate = filterUpdate.map(x => {
                                let temp = Object.assign({}, x);
                                temp.plastic = this.form.plastic;
                                temp.cost = this.form.cost
                                return temp;
                            })
                        }
                        if (filterUpdate.length > 0) {
                            this.msg = `กำลังอัพเดทข้อมูล จาก 1 ถึง ${filterUpdate.length} กรุณารอสักครู่`;
                            this.status = 1;
                            this.showLoadingModal();
                            this.recursiveUpdate(filterUpdate, 0)
                        } else {
                            this.msg = `อัพเดทข้อมูลเสร็จเรียบร้อยแล้ว`;
                            this.status = 2;
                            this.getList();
                            this.onCancel();
                            this.clearModal();
                            this.onCancelPlastic();
                            this.clearPlastic();
                        }
                    })
                })
            })
        },
        recursiveUpdate(item, index) {
            this.$store.dispatch('Standard/saveCost', item[index]).then(() => {
                let i = index + 1;
                this.msg = `กำลังอัพเดทข้อมูล จาก ${i} ถึง ${item.length} กรุณารอสักครู่`;
                this.status = 1;
                if (item.length == i) {
                    this.msg = `อัพเดทข้อมูลเสร็จเรียบร้อยแล้ว`;
                    this.status = 2;
                    this.getList();
                    this.onCancel();
                    this.clearModal();
                    this.onCancelPlastic();
                    this.clearPlastic()
                } else
                    this.recursiveUpdate(item, i)
            })
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
